import React from "react"
import { useIntl } from "../hooks"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import colors from "../styles/theme/colors"

export default function HowItWorks() {
  const data = useStaticQuery(graphql`
    fragment FileFrag on File {
      id
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    query {
      integrationLogos: file(relativePath: { eq: "HowItWorks/integration-logos.png" }) {
        ...FileFrag
      }
      addPublishers: file(relativePath: { eq: "HowItWorks/add-publishers-2x.png" }) {
        ...FileFrag
      }
      powerfulIntegrations: file(relativePath: { eq: "HowItWorks/powerful-integrations.png" }) {
        ...FileFrag
      }
      contentDelivery: file(relativePath: { eq: "HowItWorks/content-delivery.png" }) {
        ...FileFrag
      }
      contentRequest: file(relativePath: { eq: "HowItWorks/content-request.png" }) {
        ...FileFrag
      }
      trackAndMeasure: file(relativePath: { eq: "HowItWorks/track-and-measure.png" }) {
        ...FileFrag
      }
    }
  `)
  const { t } = useIntl()
  return (
    <>
      <div
        className="mt-2 w-screen h-30vh"
        style={{
          background: `linear-gradient(-5deg, ${colors.lightGrey} 50%, ${colors.white} 50%)`,
        }}
      />
      <div className="w-full bg-lightGrey">
        <div className="container">
          <div className="laptop:pt-6 flex justify-center">
            <div className="z-20 laptop:w-8/12">
              <div className="mb-1.25">
                <h5 className="text-darkGrey text-h6 leading-h6 tracking-12 font-black">
                  {t("Home__HowItWorks--Subheading")}
                </h5>
              </div>
              <div className="mb-4 laptop:mb-2.5">
                <h3 className="text-h4 leading-h4 tracking-11 text-body font-serif">
                  {t("Home__HowItWorks--Heading")}
                </h3>
              </div>
            </div>
          </div>
          <div className="space-y-5 laptop:pt-13.5 laptop:pb-10 flex flex-col items-center bg-lightGrey">
            {/* Features First Section */}
            <div className="flex flex-col laptop:flex-row space-y-5 laptop:space-y-0 laptop:space-x-5">
              <div className="w-full laptop:w-1/3 rounded-32 bg-white flex flex-col justify-between overflow-hidden">
                <div className="pt-5.5 px-4">
                  <div className="mb-1.25">
                    <h3 className="font-serif text-h5 laptop:text-h4 leading-h5 laptop:leading-h4 text-body laptop:tracking-11">
                      {t("Home__HowItWorks--AddPublishers-Heading")}
                    </h3>
                  </div>
                  <p className="text-body text-p tracking-10 leading-h6">{t("Home__HowItWorks--AddPublishers-Desc")}</p>
                </div>
                <div className="-mb-20 mt-4 -ml-6 tablet:ml-2/12 tablet:w-7/12 w-110% laptop:-mb-14 mr-1/12">
                  <Img fluid={data.addPublishers.childImageSharp.fluid} alt="add publishers" />
                </div>
              </div>
              <div className="w-full laptop:w-2/3 flex flex-col space-y-6 laptop:space-y-6 justify-between rounded-32 bg-white overflow-hidden">
                <div className="pt-5 px-4 flex flex-col laptop:flex-row laptop:space-x-5">
                  <div className="w-full laptop:w-1/2">
                    <div className="mb-1.25">
                      <h3 className="font-serif text-h5 laptop:text-h4 leading-h5 laptop:leading-h4 text-body laptop:tracking-11">
                        {t("Home__HowItWorks--Integrations-Heading")}
                      </h3>
                    </div>
                    <p className="text-body text-p tracking-10 leading-h6">
                      {t("Home__HowItWorks--Integrations-Desc")}
                    </p>
                  </div>
                  <div className="mt-3.5 laptop:mt-0 w-full laptop:w-1/2">
                    <Img
                      fluid={data.integrationLogos.childImageSharp.fluid}
                      className="tablet:w-56 tablet:h-auto tablet:mx-auto"
                      alt="socialie integration logos"
                    />
                  </div>
                </div>
                <div className="se:-ml-1/12 se:-mr-2/12">
                  <Img fluid={data.powerfulIntegrations.childImageSharp.fluid} alt="powerful integrations" />
                </div>
              </div>
            </div>
            <div className="w-full flex flex-col laptop:flex-row space-y-5 laptop:space-y-0 laptop:space-x-5">
              <div className="w-full laptop:w-2/3 flex flex-col space-y-4 laptop:space-y-6.5 justify-between rounded-32 bg-white overflow-hidden">
                <div className="pt-5.5 px-4">
                  <div className="mb-1.25">
                    <h3 className="font-serif text-h5 laptop:text-h4 leading-h5 laptop:leading-h4 text-body laptop:tracking-11">
                      {t("Home__HowItWorks--ContentDelivery-Heading")}
                    </h3>
                  </div>
                  <p className="text-body text-p tracking-10 leading-h6">
                    {t("Home__HowItWorks--ContentDelivery-Desc")}
                  </p>
                </div>
                <div className="se:-ml-3/12">
                  <Img fluid={data.contentDelivery.childImageSharp.fluid} alt="content delivery" />
                </div>
              </div>
              <div className="w-full laptop:w-1/3 flex flex-col space-y-6.5 laptop:space-y-6.5 justify-between rounded-32 bg-white overflow-hidden">
                <div className="pt-5.5 px-4">
                  <div className="mb-1.25">
                    <h3 className="font-serif text-h5 laptop:text-h4 leading-h5 laptop:leading-h4 text-body laptop:tracking-11">
                      {t("Home__HowItWorks--ContentRequest-Heading")}
                    </h3>
                  </div>
                  <p className="text-body text-p tracking-10 leading-h6">
                    {t("Home__HowItWorks--ContentRequest-Desc")}
                  </p>
                </div>
                <div className="w-full flex justify-end">
                  <div className="tablet:pt-5 w-8/12tablet:max-h-80 w-10/12">
                    <Img fluid={data.contentRequest.childImageSharp.fluid} alt="content request" />
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full flex flex-col justify-between rounded-32 bg-white space-y-5 overflow-hidden">
              <div className="pt-5.5 px-4">
                <div className="max-w-85">
                  <div className="max-w-50 laptop:max-w-75">
                    <div className="mb-1.25">
                      <h3 className="font-serif text-h5 laptop:text-h4 leading-h5 laptop:leading-h4 text-body laptop:tracking-11 break-words">
                        {t("Home__HowItWorks--TrackMeasure-Heading")}
                      </h3>
                    </div>
                  </div>
                  <p className="text-body text-p tracking-10 leading-h6">{t("Home__HowItWorks--TrackMeasure-Desc")}</p>
                </div>
              </div>
              <div className="w-150% tablet:w-100% laptop:w-120% h-full flex justify-center">
                <Img
                  fluid={data.trackAndMeasure.childImageSharp.fluid}
                  alt="track and measure performance"
                  className="-mb-5 tablet:-mb-12 laptop:-mb-22 tablet:w-100% -ml-4/12 -mr-1/12 tablet:-ml-5/12 tablet:-mr-2/12 laptop:-mr-4/12 w-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
